(function(){
var views=['whole','cube','spacer','wearing','scene'];
var stage=document.getElementById('pdpStage');
if(!stage)return;
var mainImg=document.getElementById('pdpMainImg');
var mainSrc=mainImg?mainImg.src:'';
var lbImg=(function(){var l=document.getElementById('pdpLightbox');return l?l.querySelector('img'):null;})();
function setView(v,src){if(!stage)return;stage.dataset.view=v;if(mainImg){mainImg.src=src||mainSrc;}if(lbImg){lbImg.src=src||mainSrc;}document.querySelectorAll('.pdp-thumb').forEach(function(b){b.classList.toggle('is-active',b.dataset.view===v);});}
document.querySelectorAll('.pdp-thumb').forEach(function(b){b.addEventListener('click',function(){setView(b.dataset.view,b.dataset.src||'');});});
var vmap=null;
try{var _ve=document.getElementById('pdpVariantImages');vmap=_ve?JSON.parse(_ve.textContent):null;}catch(_e){vmap=null;}
function setVariantImage(id){
if(!vmap||!mainImg)return;
var url=vmap[String(id)];
if(!url||url===mainImg.src)return;
mainSrc=url;
document.querySelectorAll('.pdp-thumb').forEach(function(b){
var v=b.dataset.view;
if(v==='whole'||v==='cube'||v==='spacer'){var im=b.querySelector('img');if(im)im.src=url;}
});
setView('whole',url);
}
document.querySelectorAll('.pdp-varpill').forEach(function(p){
p.addEventListener('click',function(){setVariantImage(p.getAttribute('data-variant-id'));});
});
var _idInput=document.querySelector('.product-variant-id');
if(_idInput){setVariantImage(_idInput.value);}
var lb=document.getElementById('pdpLightbox');
function openLb(){if(!lb)return;lb.hidden=false;document.body.style.overflow='hidden';}
function closeLb(){if(!lb)return;lb.hidden=true;document.body.style.overflow='';}
if(stage){stage.addEventListener('click',openLb);stage.addEventListener('keydown',function(e){if(e.key==='Enter')openLb();});}
var sx=null;
stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
stage.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){var i=views.indexOf(stage.dataset.view);i=(i+(dx>0?-1:1)+views.length)%views.length;setView(views[i]);}sx=null;},{passive:true});
if(lb){lb.addEventListener('click',closeLb);document.addEventListener('keydown',function(e){e.key==='Escape'&&closeLb();});}
})();
